import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const DetailsRow = styled.div`
  ${media.xl`
    padding-left: 0;
  `}
  margin-bottom: 10px;
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${media.xl`
    padding-left: 10px;
  `}
`;
